export const REQUEST_STATUS = {
  SEND: 1,
  ACCEPT: 2,
  REJECT: 3,
};
